const email_config = {
   
service_name : "service_k58ld7n",
email_template : "template_f6oe3tu",
user_id : "user_w0BhuVLN1mYTkaDSQ84OK",
to_email : "wejdigharbi@yahoo.fr"
}

export default email_config;